type SetCookieParams = {
    name: string;
    value: string;
    encodeValue?: boolean;
    domain?: string;
    path?: string;
    maxAgeSec?: number;
    secure?: boolean;
    sameSite?: 'Strict' | 'Lax' | 'None';
};

type DeleteCookieParams = {
    name: string;
    domain?: string;
    path?: string;
};

const setCookie = ({
    name,
    value,
    encodeValue = true,
    domain,
    path = '/',
    maxAgeSec,
    secure,
    sameSite,
}: SetCookieParams): void => {
    const normalizedValue = encodeValue ? encodeURIComponent(value) : value;
    let cookie = `${encodeURIComponent(name)}=${normalizedValue}`;

    if (domain) cookie += `; domain=${domain}`;
    if (path) cookie += `; path=${path}`;
    if (maxAgeSec !== undefined) cookie += `; max-age=${maxAgeSec}`;
    if (secure) cookie += '; secure';
    if (sameSite) cookie += `; samesite=${sameSite}`;

    document.cookie = cookie;
};

const deleteCookie = ({name, domain, path = '/'}: DeleteCookieParams): void => {
    setCookie({name, value: '', domain, path, maxAgeSec: 0});
};

const getCookie = (name: string): string | null => {
    const encoded = encodeURIComponent(name);
    const cookies = document.cookie.split('; ');

    for (const cookie of cookies) {
        const [cookieName, ...rest] = cookie.split('=');

        if (cookieName === encoded) {
            try {
                return decodeURIComponent(rest.join('='));
            } catch {
                return null;
            }
        }
    }

    return null;
};

const hasCookie = (name: string): boolean => getCookie(name) !== null;

const clearAllCookies = (): void => {
    document.cookie.split('; ').forEach((cookie) => {
        if (!cookie) return;

        const rawName = cookie.split('=')[0];

        if (!rawName) return;

        try {
            deleteCookie({name: decodeURIComponent(rawName)});
        } catch {
            // skip cookies with malformed names
        }
    });
};

export {clearAllCookies, deleteCookie, getCookie, hasCookie, setCookie};
